// Browser-side upload pipeline for the SPA. Mirrors
// medias/static/medias/image-upload.js, which cannot import from here:
// ManifestStaticFilesStorage does not rewrite `import` specifiers and
// forms.Media emits a plain <script src> with no type="module".
import { client } from '../api/client';
import { computeTargetSize } from './imageResize';

// Profile photos are shown small on the web; no original is kept.
export const PROFILE_MAX_EDGE = 800;
export const PROFILE_QUALITY = 0.85;

export async function prepareImage(file, maxEdge, quality) {
    const bitmap = await createImageBitmap(file, {
        imageOrientation: 'from-image',
    });
    // Resize via drawImage, not createImageBitmap's resizeWidth, which only
    // constrains the width and would leave tall images uncapped.
    const size = computeTargetSize(bitmap.width, bitmap.height, maxEdge);
    const canvas = document.createElement('canvas');
    canvas.width = size.width;
    canvas.height = size.height;
    canvas.getContext('2d').drawImage(bitmap, 0, 0, size.width, size.height);
    bitmap.close();

    const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, 'image/webp', quality);
    });
    if (!blob) {
        throw new Error('Image encoding failed');
    }
    return blob;
}

export async function uploadBlob(blob) {
    // Presign through the app client so JWT refresh is handled for us.
    const { data } = await client.post('/api/medias/upload-url/', {
        content_type: blob.type,
        size: blob.size,
    });

    // Bare fetch on purpose: any wrapper that adds an Authorization header or
    // its own Content-Type breaks the signature and R2 answers 403.
    const put = await fetch(data.upload_url, {
        method: data.upload_method,
        headers: data.upload_headers,
        body: blob,
    });
    if (!put.ok) {
        throw new Error(`Storage rejected the upload (${put.status})`);
    }
    return data.file_url;
}
